import { LinkButton, Spacer } from '@dot/design-system';
import { Trans, useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

import { Heading, Text } from '../styles';

import { SecuredByBadge } from '@/components/SecuredByBadge/SecuredByBadge';
import { QRCode } from '@/components/qr-code';
import { ShortenedUrl } from '@/components/shortened-url';
import { fontTextMdRegular } from '@/styles/helpers';

const QrWrapper = styled.div`
  height: 12.5rem;
  width: 12.5rem;
`;

const StandardLinkButton = styled(LinkButton)`
  color: ${(p) => p.theme.colors.oxfordBlue[80]};
  ${fontTextMdRegular};
  text-decoration: underline;
`;

type Props = {
  isLoading: boolean;
  /** Absent when BFF marks `mobile_redirect` as non-skippable (`/info` `skippable: false`). */
  onContinueOnThisDevice?: () => void;
  onTutorialClick: () => void;
  qrCode: string | null;
  shortUrl?: string;
};

export const QrScan = ({ isLoading, onContinueOnThisDevice, onTutorialClick, qrCode, shortUrl }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Heading>{t('steps.mobileRedirect.heading')}</Heading>
      <Spacer $top={0.625}>
        <Text>{t('steps.mobileRedirect.subheading')}</Text>
      </Spacer>
      <QrWrapper>
        <QRCode qrCode={qrCode} />
      </QrWrapper>
      <Text>
        <Trans
          components={{ tutorial_link: <StandardLinkButton onClick={onTutorialClick} /> }}
          i18nKey="steps.mobileRedirect.tutorial.textWithLink"
        />
        <ShortenedUrl isLoading={isLoading} shortUrl={shortUrl} />
      </Text>
      {onContinueOnThisDevice && (
        <Spacer $top={1.25}>
          <LinkButton data-test-id="btn_cancel_mobile_redirect" onClick={onContinueOnThisDevice} type="button">
            {t('steps.mobileRedirect.returnButton')}
          </LinkButton>
        </Spacer>
      )}
      <Spacer $top={2.5}>
        <SecuredByBadge />
      </Spacer>
    </>
  );
};
